module.exports = __webpack_public_path__ + "img/phone_scoremaster.e67d39e6.jpg";